/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, arrayOf, string, array, func,
} from 'prop-types';
import { connect } from 'react-redux';
import DeliveryTable from '../../../DeliveryTable/DeliveryTable';
import CountDownTimerBanner from '../CountDownTimerBanner/CountDownTimerBanner';
import { getPresentationFamily } from '../../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getDataDictionary } from '../../../../../../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    imocWrapper: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        padding: '10px 0',
        margin: '0 auto',
        border: '0',
        alignItems: 'center',
        [theme.breakpoints.up(769)]: {
            flexDirection: 'row',
            margin: '0 auto',
            padding: '25px 0',
        },
    },
    centerHero: {
        justifyContent: 'center',
    },
    TopimocWrapper: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        margin: '25px auto',
        border: '0',
        borderBottom: 'solid 1px #ccc',
        paddingBottom: '10px',
    },
    header: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '24px',
        whiteSpace: 'nowrap',
        color: theme.palette.colorPrimary,
        paddingRight: '40px',
        margin: '0',
        lineHeight: '40px',
        alignSelf: 'flex-start',
        [theme.breakpoints.up(769)]: {
            borderRight: `1px solid ${theme.palette.colorNeutral60}`,
            alignSelf: 'center',
            margin: '0 40px 0 0',
        },
    },
    headerImocFood: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '24px',
        whiteSpace: 'nowrap',
        color: theme.palette.colorPrimary,
        paddingRight: '40px',
        margin: '0',
        lineHeight: '40px',
        alignSelf: 'flex-start',
        [theme?.breakpoints?.up(769)]: {
            alignSelf: 'center',
            margin: '0 40px 0 0',
        },
        [theme?.breakpoints?.down(769)]: {
            alignSelf: 'center',
            margin: '0 0 0 16px',
            fontSize: '16px',
        },
    },
    noImocCopyStyling: {
        paddingRight: 0,
        [theme.breakpoints.up(769)]: {
            borderRight: 'none',
            margin: 0,
        },
    },
    headerTop: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '24px',
        borderRight: `1px solid ${theme.palette.colorNeutral60}`,
        whiteSpace: 'nowrap',
        color: theme.palette.colorPrimary,
        paddingRight: '40px',
        paddingLeft: '110px',
        margin: '0 40px 0 0',
        lineHeight: '40px',
        letterSpacing: '1.2px',
        alignSelf: 'center',
    },
    imocCopyContainer: {
        display: 'block',
    },
    TopimocCopyContainer: {
        display: 'block',
        width: '66%',
        textAlign: 'left',
        paddingLeft: '2%',
        paddingRight: '5%',
        fontSize: '23px',
        fontFamily: 'latoregular',
        [theme?.breakpoints?.up(769)]: {
            borderLeft: `1px solid ${theme.palette.colorNeutral60}`,
        },
        [theme?.breakpoints?.down(769)]: {
            width: '100%',
            fontSize: '12px',
        },
    },
    copy: {
        display: 'inline',
        '& p': {
            margin: 0,
            lineHeight: '23px',
            fontSize: '14px',
            display: 'inline',
        },
        '& h2, & h3, & h4, & h5, & h6': {
            margin: 0,
        },
        '& h2': {
            fontWeight: 'normal',
            fontSize: '24px',
        },
        '& h3': {
            fontWeight: 'normal',
            fontSize: '20px',
        },
        fontFamily: theme.typography.fontFamily,
        '& a': {
            color: theme.palette.colorPrimary,
        },
    },
    imocCopy: {
        display: 'inline',
        '& p': {
            margin: 0,
            lineHeight: '23px',
            fontSize: '18px',
            display: 'inline',
            [theme?.breakpoints?.down(769)]: {
                margin: '0',
                fontSize: '15px',
                lineHeight: '18px',
            },
        },
        '& h2, & h3, & h4, & h5, & h6': {
            margin: 0,
        },
        '& h2': {
            fontWeight: 'normal',
            fontSize: '24px',
        },
        '& h3': {
            fontWeight: 'normal',
            fontSize: '20px',
        },
        fontFamily: theme.typography.fontFamily,
        '& a': {
            color: theme.palette.colorPrimary,
        },
    },
    readMoreCopy: {
        '& p:not(:last-child)': {
            marginBottom: '10px',
            display: 'block',
        },
    },
    readMore: {
        display: 'inline',
        marginLeft: '4px',
        color: theme.palette.colorPrimary,
        fontSize: '14px',
        textDecoration: 'underline',
        cursor: 'pointer',
        border: 'none',
        padding: 0,
        backgroundColor: '#FFF',
        '&:focus': {
            outline: 0,
        },
    },
    displayNone: {
        display: 'none',
    },
    imgLogo: {
        display: 'block',
        borderRight: `1px solid ${theme.palette.colorNeutral60}`,
        maxHeight: '90px',
        padding: '10px 40px 10px 40px',
        margin: '0 40px 0 0',
    },
    offer: {
        position: 'absolute',
        fontSize: '12px',
        fontStyle: 'italic',
        bottom: '5px',
        right: '5px',
        color: theme.palette.colorPrimary,
    },
    imocBackgroundWrapper: {
        margin: '0 -15px 0 -15px',
        padding: '0 15px 0 15px',
        background: theme?.palette?.common?.lightPurple || '#f4f2f7',
    },
    doubleOfferContainer: {
        display: 'flex',
        width: '100%',
    },
    doubleOffer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
        textAlign: 'center',
        borderRight: `1px solid ${theme.palette.colorNeutral60}`,
        '& > h2, & > h3, & > p, & > *': {
            lineHeight: 1.3,
            margin: 0,
        },
        '&::after': {
            transform: 'translate(0,-50%)',
            content: '"OR"',
            fontSize: '14px',
            color: '#000',
            position: 'absolute',
            top: '50%',
            right: '-11px',
            backgroundColor: '#fff',
            padding: '5px 0',
        },
        '&:last-child': {
            borderRight: 'none',
            '&::after': {
                display: 'none',
                content: '""',
            },
        },
    },
});

class DesktopTabletImoc extends Component {
    constructor(props) {
        super(props);
        this.imocHeightRef = React.createRef();
        this.state = {
            toggleFlag: true,
        };
    }

    componentDidMount() {
        const { imocHeightHandler } = this.props;
        if (this.imocHeightRef?.current && imocHeightHandler) {
            imocHeightHandler(this.imocHeightRef?.current?.clientHeight || 0);
        }
    }

    handleClick = () => {
        this.setState((prevState) => ({
            toggleFlag: !prevState.toggleFlag,
        }));
    }

    render() {
        const {
            classes, imocBlock, brand, presentation_family, samedayCutoff, brandData, dataDictionary,
        } = this.props;
        const { toggleFlag } = this.state;
        const imocGroupArray = imocBlock;
        // if no IMOC block in CMS render dummy div for spacing
        if (!imocGroupArray) { return <div style={{ height: '15px' }} />; }
        let imocData; let layout; let h1; let imocCopy; let imocReadMoreCopy;
        let imocShowSameDay; let imocBackgroundColor; let countDownColors;
        if (imocGroupArray) {
            imocGroupArray.forEach((block) => {
                // api call will return web_imoc + mobile_imoc || or just web_imoc
                // mobile imoc is for native mobile app ( that doesnt exsist yet )
                if (block.name?.toLowerCase() !== 'mobile imoc') {
                    imocData = block;
                    layout = block?.layout || '';
                    h1 = block?.header || '';
                    imocCopy = block?.copy || '';
                    imocReadMoreCopy = block?.read_more_copy || null;
                    imocShowSameDay =  block?.show_same_day_cutoff_times || null;
                    imocBackgroundColor = block?.background_color;
                    countDownColors = block?.count_down_colors;
                }
            });
        }

        return (
            <div data-testid="desktop-imoc" className={`${brandData?.code === 'CAN' ? classes.imocBackgroundWrapper : ''} `} ref={this.imocHeightRef}>
                {imocShowSameDay && <CountDownTimerBanner samedayCutoff={samedayCutoff} countDownColors={countDownColors} dataDictionary={dataDictionary} /> }
                <div
                    style={imocBackgroundColor ? {
                        backgroundColor: imocBackgroundColor, padding: '25px 5px 25px 5px', marginBottom: '10px',
                    } : null}
                    className={!imocCopy ? `${classes.imocWrapper} ${classes.centerHero}` : `${classes.imocWrapper}`}
                >
                    {imocData?.image ? (
                        <img src={imocData?.image?.url} className={classes.imgLogo} alt="" />
                    ) : (
                        <h1
                        // eslint-disable-next-line no-nested-ternary
                            className={presentation_family === 'food' ? classes.headerImocFood : !imocCopy ? classes.noImocCopyStyling : classes.header}
                        >
                            {h1}
                        </h1>
                    )}

                    {/* render double offer here */}
                    {layout === 'double offer' ? (
                        <div className={classes.doubleOfferContainer}>
                            {imocData?.offer_section?.offer_copy?.map((offer) => (
                                <ReactMarkdown
                                    source={offer}
                                    skipHtml
                                    className={classes.doubleOffer}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className={(brand === 'harryanddavid') ? classes.TopimocCopyContainer : classes.imocCopyContainer}>
                            <ReactMarkdown
                                source={imocCopy}
                                skipHtml
                                className={(brand === 'harryanddavid') ? classes.imocCopy : classes.copy}
                            />

                            {imocShowSameDay && <DeliveryTable samedayCutoff={samedayCutoff} />}

                            {imocReadMoreCopy
                                ? (
                                    <>
                                        <ReactMarkdown
                                            source={imocReadMoreCopy}
                                            skipHtml
                                            className={toggleFlag ? `${classes.displayNone}` : `${classes.copy} ${classes.readMoreCopy}`}
                                        />
                                        <button type="button" className={classes.readMore} onClick={this.handleClick}>
                                            {toggleFlag ? 'Show more' : 'Close'}
                                        </button>
                                    </>
                                ) : null }
                        </div>

                    )}

                    {layout === 'no offer' || !layout ? null : <a className={classes.offer} href="#disclaimer">*Offer Details</a>}

                </div>
            </div>
        );
    }
}

DesktopTabletImoc.propTypes = {
    imocBlock: arrayOf(
        shape({
            layout: string,
            header: string.isRequired,
            copy: string.isRequired,
            read_more_copy: string,
            image: object,
            offer_section: object,
        }),
    ).isRequired,
    classes: object.isRequired,
    brand: string.isRequired,
    presentation_family: string,
    brandData: shape({
        code: string,
    }),
    samedayCutoff: shape({
        entries: arrayOf(shape({
            cutoff_entries: array,
        })),
    }),
    imocHeightHandler: func,
    dataDictionary: object,
};

DesktopTabletImoc.defaultProps = {
    samedayCutoff: {},
    presentation_family: '',
    brandData: null,
    imocHeightHandler: null,
    dataDictionary: {},
};

const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
    brandData: getBrand(state),
    dataDictionary: getDataDictionary(state),
});

export default connect(mapStateToProps)(withStyles(styles)(DesktopTabletImoc));
